module.exports = __webpack_public_path__ + "fransa mutfak 5.jpg?51427a8baeeac96c375d1756e473e2b9";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/fransa mutfak 5.jpg
// module id = 329
// module chunks = 0